import { render } from "./SurveyDefaultsForm.vue?vue&type=template&id=afc52fb6"
import script from "./SurveyDefaultsForm.vue?vue&type=script&lang=js"
export * from "./SurveyDefaultsForm.vue?vue&type=script&lang=js"

import "./SurveyDefaultsForm.vue?vue&type=style&index=0&id=afc52fb6&lang=scss"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__